var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('selector',{attrs:{"options":_vm.options},model:{value:(_vm.editingSource),callback:function ($$v) {_vm.editingSource=$$v},expression:"editingSource"}})}
var staticRenderFns = []

export { render, staticRenderFns }